<div class="audit-log-modal">
  <div class="modal-header">
    <h4 class="modal-title">Audit Log - Order #{{ orderId }}</h4>
  </div>

  <div class="modal-body">
    <!-- Loading State -->
    @if (isLoading) {
      <div class="text-center py-4">
        <div class="spinner-border text-dark" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2 text-muted">Loading audit logs...</p>
      </div>
    }

    <!-- Error State -->
    @if (!isLoading && errorMessage) {
      <div class="alert alert-danger">
        {{ errorMessage }}
      </div>
    }

    <!-- Content -->
    @if (!isLoading && !errorMessage) {
      <div>
        <!-- Order Info -->
        <div class="mb-3">
          <small class="text-muted">Note: Sorted so most recent entries are at the top</small>
          <span class="float-end text-muted"><small>{{ auditLogs.length }} entries</small></span>
        </div>
        <!-- Full Audit Log -->
        <div class="table-responsive audit-log-table-container">
          <table class="table table-sm table-striped mb-0">
            <thead>
              <tr>
                <th>Name</th>
                <th>Event</th>
                <th>Document</th>
                <th>Date</th>
                <th>Data</th>
              </tr>
            </thead>
            <tbody>
              @for (log of auditLogs; track log) {
                <tr>
                  <td [title]="getFullName(log)">{{ getFullName(log) }}</td>
                  <td [title]="log.eventTypeCode">{{ log.eventTypeCode }}</td>
                  <td [title]="log.documentName || '-'">{{ log.documentName || '-' }}</td>
                  <td [title]="formatDateTime(log.createdDate)">{{ formatDateTime(log.createdDate) }}</td>
                  <td class="data-cell" [title]="log.eventAuditData || '-'">
                    @if (log.eventAuditData) {
                      <span class="data-text">
                        {{ log.eventAuditData }}
                      </span>
                    }
                    @if (!log.eventAuditData) {
                      <span>-</span>
                    }
                  </td>
                </tr>
              }
              @if (auditLogs.length === 0) {
                <tr>
                  <td colspan="5" class="text-center text-muted py-3">No audit logs found</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
  </div>
</div>
